import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

/**
 * Required conversation attributes, Teletel's own path.
 *
 * The Chatwoot feature of the same name is premium and stays paywalled and
 * untouched; this is a separate route, component and API. The controller has
 * shipped since the flows batch - this route is what finally makes it reachable
 * without a console.
 *
 * Administrators only. The server enforces the same rule, so hiding the route
 * is a convenience, never the control.
 */
export default {
  routes: [
    {
      path: frontendURL(
        'accounts/:accountId/settings/teletel-required-attributes'
      ),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'teletel_required_attributes',
            params: to.params,
          }),
        },
        // Owner order 2026-09-29: required fields are edited in one place,
        // Settings → Conversation workflow. The old address stays as a
        // redirect so saved links and guide articles keep working.
        {
          path: 'list',
          name: 'teletel_required_attributes',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => ({
            name: 'conversation_workflow_index',
            params: to.params,
          }),
        },
      ],
    },
  ],
};
